/**
 * Authenticated WebRTC signaling over HTTPS/WSS (ticket #1824, "N3").
 *
 * iroh-router signaling is explicitly deferred; this is the browser-side
 * contract for the HTTPS/WSS signaling adapter instead. It carries only
 * setup, offer, answer, candidate, restart, and close — never a peer
 * connection or DataChannel. Field names mirror the Rust wire types in
 * `core/adapters-network/src/webrtc_signal/messages.rs` exactly (including
 * snake_case) since both sides serialize the same JSON envelope.
 *
 * `WebRtcHomeNodeClient` (the WebRTC carrier, ticket "N4") depends on this
 * narrow port rather than on any concrete transport, so the signaling
 * transport can change without touching WebRTC connection logic.
 */
export const WEBRTC_SIGNAL_VERSION = 1;
/** Maximum serialized size of one signaling WebSocket text frame. */
export const MAX_WEBRTC_SIGNAL_MESSAGE_BYTES = 32 * 1024;
/** Maximum SDP body size (offer, answer, or restart). */
export const MAX_SDP_BYTES = 16 * 1024;
export const MIN_OFFER_NONCE_BYTES = 16;
export const MAX_OFFER_NONCE_BYTES = 128;
/** Maximum DTLS fingerprint size: `<algorithm> <hex-pairs>`. */
export const MAX_DTLS_FINGERPRINT_BYTES = 200;
/** Maximum size of one trickle-ICE candidate line. */
export const MAX_ICE_CANDIDATE_BYTES = 1024;
export const MAX_SDP_MID_BYTES = 64;
/** Maximum number of trickle-ICE candidates accepted for one bound offer. */
export const MAX_ICE_CANDIDATES_PER_OFFER = 32;
export const MAX_CLOSE_REASON_BYTES = 256;
//# sourceMappingURL=webrtc-signaling.js.map